import { ILSImagePlaceholder } from "@components/ILSPlaceholder";
import PropTypes from "prop-types";
import React from "react";
import { Header, Segment } from "semantic-ui-react";

export const SpecialCollectionAccess = ({ metadata, isLoading }) => {
  return (
    <Segment className="highlighted">
      <ILSImagePlaceholder style={{ height: 200 }} isLoading={isLoading}>
        <Header as="h3">Access online</Header>
        <br />
        No e-resources currently availabile. These materials are archived for
        research and reference purposes only.
      </ILSImagePlaceholder>
    </Segment>
  );
};

SpecialCollectionAccess.propTypes = {
  metadata: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
};

SpecialCollectionAccess.defaultProps = {
  isLoading: false,
};
